import { Pipe, PipeTransform } from '@angular/core'
import { ProductCategory } from '@mmx/shared'
import { find } from 'lodash'

@Pipe({
  name: 'labelPC',
  standalone: false,
})
export class LabelPCPipe implements PipeTransform {
  transform(categoryId: string, productCategories: ProductCategory[]) {
    const productCategory = find(productCategories, (category) => {
      return category.id === categoryId
    })

    if (productCategory) {
      return productCategory.label
    }
  }
}
